import vbAttachmentTokenService from "../services/vbAttachmentTokenService";
import Vue from "vue";
import attachmentService from "../services/attachmentService";
import constants from "../constants";
import buildAttachmentURL from "../filters/buildAttachmentURL";

export default {

  data() {
    return {
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      vbAttachmentsState: {},
    }
  },

  filters: {buildAttachmentURL},

  methods: {

    downloadAttachment(item, objectType) {
      attachmentService
        .findAll({
          objectId: item.vbOutgoingDocUserViewKey ?
            item.vbOutgoingDocUserViewKey.id : item.vbIncomingDocUserViewKey ?
              item.vbIncomingDocUserViewKey.id : item.id,
          objectType: objectType
        })
        .then(response => {
          if (response.data && response.data.length) {
            let vbAttachment = response.data[0];
            let token = this.getToken(vbAttachment.id);
            let path = this.$options.filters.buildAttachmentURL(token, {
              type: (item.vbDocUserVbDocProcessId || item.status === constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH)
                ? this.DOWNLOAD_OPTION.TYPE.PDF
                : this.DOWNLOAD_OPTION.TYPE.ORIGINAL
            })
            if (path) window.open(path, '_blank');
            else this.downloadAttachment(item, objectType);
          }
        });
    },

    getToken(vbAttachmentId) {
      // console.log('vbAttachmentIdsss', vbAttachmentId)

      if (!vbAttachmentId || !vbAttachmentId.length) return null;

      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});

      let vbAttachmentState = this.vbAttachmentsState[vbAttachmentId];

      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {

          Vue.set(this.vbAttachmentsState, vbAttachmentId, vbAttachmentState = {
            vbAttachmentId: vbAttachmentId,
            already: false
          });

          vbAttachmentTokenService
            .getToken(vbAttachmentId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },

    getTokenForViewVbTlt(vbAttachmentId) {
      if (!vbAttachmentId || !vbAttachmentId.length) return null;
      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});
      let vbAttachmentState = this.vbAttachmentsState[vbAttachmentId];
      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {
          Vue.set(this.vbAttachmentsState, vbAttachmentId, vbAttachmentState = {
            vbAttachmentId: vbAttachmentId,
            already: false
          });
          vbAttachmentTokenService
            .getTokenForViewVbTlt(vbAttachmentId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },

    getTokenForConfigLD(vbAttachmentId) {
      if (!vbAttachmentId || !vbAttachmentId.length) return null;
      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});
      let vbAttachmentState = this.vbAttachmentsState[vbAttachmentId];
      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {
          Vue.set(this.vbAttachmentsState, vbAttachmentId, vbAttachmentState = {
            vbAttachmentId: vbAttachmentId,
            already: false
          });
          vbAttachmentTokenService
            .getTokenForConfigLD(vbAttachmentId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },

    getTokenDocRelation(docRelation) {
      let docRelationId = docRelation.id;
      console.log('docRelationId', docRelationId)

      if (!docRelationId || !docRelationId.length) return null;

      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});

      let vbAttachmentState = this.vbAttachmentsState[docRelationId];

      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {

          Vue.set(this.vbAttachmentsState, docRelationId, vbAttachmentState = {
            vbAttachmentId: docRelationId,
            already: false
          });

          vbAttachmentTokenService
            .getTokenDocRelation(docRelationId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },

    getTokenDocRelationForConfigLD(docRelation) {
      let docRelationId = docRelation.id;
      if (!docRelationId || !docRelationId.length) return null;
      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});
      let vbAttachmentState = this.vbAttachmentsState[docRelationId];
      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {
          Vue.set(this.vbAttachmentsState, docRelationId, vbAttachmentState = {
            vbAttachmentId: docRelationId,
            already: false
          });

          vbAttachmentTokenService
            .getTokenDocRelationForConfigLD(docRelationId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },


    getTokenAttachmentComment(vbAttachmentId) {
      if (!vbAttachmentId || !vbAttachmentId.length) return null;
      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});
      let vbAttachmentState = this.vbAttachmentsState[vbAttachmentId];
      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {
          Vue.set(this.vbAttachmentsState, vbAttachmentId, vbAttachmentState = {
            vbAttachmentId: vbAttachmentId,
            already: false
          });
          vbAttachmentTokenService
            .getTokenAttachmentComment(vbAttachmentId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },

    getTokenForBlokedRole(vbAttachmentId, blockedUserId) {
      console.log('blockedUserId',blockedUserId)
      if (!vbAttachmentId || !vbAttachmentId.length || !blockedUserId) return null;
      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});
      let vbAttachmentState = this.vbAttachmentsState[vbAttachmentId];
      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {
          Vue.set(this.vbAttachmentsState, vbAttachmentId, vbAttachmentState = {
            vbAttachmentId: vbAttachmentId,
            already: false
          });

          vbAttachmentTokenService
            .getTokenForBlockedRole(vbAttachmentId, blockedUserId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/vbAttachmentTokenMixin.js